import classNames from 'clsx';
import type { LottieRefCurrentProps } from 'lottie-react';
import React, { memo, useEffect, useRef } from 'react';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import Lottie from 'reactApp/ui/Lottie/Lottie';

import animation from './buttonAnimation.json';
import styles from './SummerSaleButtonAnimation.css';

const ANIMATION_INTERVAL = 10000;

export const SummerSaleButtonAnimation = memo(() => {
    const lottieRef = useRef<LottieRefCurrentProps | null>(null);
    const isMobile = EnvironmentSelectors.isPhone();

    useEffect(() => {
        const playAnimation = () => {
            lottieRef?.current?.goToAndPlay(0);
        };

        const intervalId = setInterval(playAnimation, ANIMATION_INTERVAL);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className={classNames(styles.root, { [styles.rootMobile]: isMobile })}>
            <Lottie animationData={animation} loop={false} autoplay={false} lottieRef={lottieRef} />
        </div>
    );
});

SummerSaleButtonAnimation.displayName = 'SummerSaleButtonAnimation';
